/**
 * Role → widget stack + top navigation for the Intelligent Workspace.
 * One config file drives layout for every persona. Adding a new persona
 * = one entry here; no dashboard rewrite.
 */
import { ROLES } from './roles';

/** Widgets are simple string keys; the Workspace page maps them to JSX. */
export const WORKSPACES = {
  [ROLES.ESG]: {
    title: 'Sustainability Command Center',
    subtitle: 'ESG posture · risk · opportunity',
    widgets: ['health_score', 'kpi_carbon', 'cbam_exposure', 'cbam_scenario', 'compliance_ai', 'risk_center', 'carbon_trend', 'product_portfolio'],
  },
  [ROLES.AUDITOR]: {
    title: 'Audit Control Center',
    subtitle: 'Evidence integrity · trust ledger · queue',
    widgets: ['health_score', 'kpi_audit', 'trust_timeline', 'risk_center', 'evidence_queue'],
  },
  [ROLES.CFO]: {
    title: 'Carbon Financial Intelligence',
    subtitle: 'CBAM exposure · savings · ROI',
    widgets: ['health_score', 'kpi_financial', 'cbam_exposure', 'cbam_scenario', 'compliance_ai', 'investment_ops'],
  },
  [ROLES.CPO]: {
    title: 'Procurement Command Center',
    subtitle: 'Supplier posture · data quality · risk',
    widgets: ['health_score', 'kpi_suppliers', 'top_suppliers', 'ai_insights', 'risk_center', 'supplier_portfolio'],
  },
  [ROLES.CSO]: {
    title: 'Sustainability Command Center',
    subtitle: 'Target trajectory · portfolio · reduction',
    widgets: ['health_score', 'kpi_carbon', 'carbon_trend', 'ai_insights', 'product_portfolio'],
  },
  [ROLES.SUPPLIER]: {
    title: 'Supplier Portal',
    subtitle: 'Requested data · uploads · trust score',
    widgets: ['health_score', 'kpi_supplier_self', 'requested_data', 'ai_insights'],
  },
  [ROLES.ADMIN]: {
    title: 'Platform Control Center',
    subtitle: 'Users · organisations · API health',
    widgets: ['health_score', 'kpi_platform', 'top_suppliers', 'cbam_exposure', 'cbam_scenario', 'compliance_ai', 'risk_center', 'evidence_queue'],
  },
  [ROLES.USER]: {
    title: 'Your Workspace',
    subtitle: 'Overview · status · next actions',
    widgets: ['health_score', 'kpi_carbon', 'ai_insights', 'product_portfolio'],
  },
};
